// extracted by mini-css-extract-plugin
export default {"header":"header__DTK6R","current":"current__iNGSs","navigation":"navigation__GTrWA","brand":"brand__LTrVA","spacer":"spacer__ARbC8"};